
// legacy kiosks have been using this font family setting from bootstrap
const SYSTEM_FONT = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";';

export const legacyConfig = (config) => {
  config.root_font_size = '16px';
  config.root_font_family = SYSTEM_FONT;
  config.cart_toolbar_bg_color = '#fdfdfd';
  config.cart_toolbar_top = '2.85rem';
  config.cart_panel_header_margin = '0.1rem 0 0.5rem !important';
  config.kiosk_bg_color = "#e6e6e6";
  config.kiosk_primary_button_background = 'linear-gradient(#4ea4c3, #007aa1)';
  config.kiosk_form_button_bg_color = 'linear-gradient(#4ea4c3, #007aa1)';
  config.kiosk_form_button_font_color = '#fff';
  //config.kiosk_form_button_border_color = '#EBA900';
  config.kiosk_form_button_border = 'none';
  config.kiosk_login_bg = 'white';
  config.kiosk_form_bg_color = 'white';
  config.kiosk_form_border = 'none';
  config.kiosk_form_border_color = '#1f8eb0';
  config.kiosk_form_header_font_color = '#101820';
  config.kiosk_form_message_font_color = '#101820';
  config.kiosk_form_label_font_color = '#101820';
  config.kiosk_form_label_font_weight = '400';
  config.kiosk_form_access_code_input_bg_color = 'white';
  //config.kiosk_form_access_code_input_border_color = '#101820';
  config.kiosk_form_access_code_input_border = '1px solid #aaa';
  config.kiosk_form_access_code_input_font_color = '#101820';
  config.kiosk_topbar_logo_height = '2rem';
  config.pwa_pswipe_footer_logo = '/img/hp_logo_horizontal.png';
  config.pwa_pswipe_footer_logo_german = '/img/hp_logo_horizontal_german.png';
  config.pwa_pswipe_footer_logo_french = '/img/hp_logo_horizontal_french.png';
  config.pwa_navbar_desktop_brand_logo = '/img/hp_logo_horizontal.png';
  config.pwa_navbar_desktop_brand_logo_german = '/img/hp_logo_horizontal_german.png';
  config.pwa_navbar_desktop_brand_logo_french = '/img/hp_logo_horizontal_french.png';
  config.pwa_pswipe_store_link = 'https://shop.harrypotterexhibition.com/';
  config.pwa_galleryimage_bg = '#101820';
  config.pwa_galleryimage_font_color = '#EBA900';
  config.pwa_navbar_font_color = '#EBA900';
  config.pwa_navbar_hover_bg_color = '#EBA900';
  config.pwa_navbar_hover_font_color = '#101820';
  config.pwa_default_font_color = '#EBA900';
  config.pwa_default_bg_color = '#EBA900';
  config.pwa_default_button_bg_color = '#EBA900';
  config.pwa_default_button_font_color = '#101820';
  config.legal_notes = 'WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)';
  config.kiosk_logout_btn_bg = 'linear-gradient(#ffffff, #f1f1f1)';
  config.kiosk_logout_btn_border = '1px solid #dcdcdc';
  config.kiosk_logout_btn_box_shadow = '0 0 2px #dcdcdc';
  config.kiosk_logout_btn_font_color = '#2b8eb0';
  config.kiosk_logout_btn_padding = '0rem 1rem';
  config.kiosk_toolbar_bg = 'white';
  config.kiosk_toolbar_header_font_color = 'rgb(33, 37, 41)';
  config.kiosk_toolbar_header_padding = '0';
  config.kiosk_toolbar_header_margin = '0.5rem 1.5rem 0.5rem 1rem !important';
  config.kiosk_cart_count_font_color = '#2b8eb0';
  config.kiosk_cart_icon_margin_right = '0.5rem';
  config.kiosk_select_all_font_color = '#343434';
  config.kiosk_modal_header_font_color = 'rgb(33, 37, 41)';
  config.kiosk_modal_content_font_color = 'rgb(33, 37, 41)';
  config.kiosk_modal_border_color = '#EBA900';
  config.kiosk_modal_button_action_bg_color = 'linear-gradient(#4ea4c3, #007aa1)';
  config.kiosk_modal_button_action_font_color = '#fff';
  config.kiosk_modal_button_action_border = 'none';
  config.kiosk_modal_bg_color = 'white';
  config.sub_font = SYSTEM_FONT;
  config.main_font = SYSTEM_FONT;
  config.kiosk_inactivity_timeout = 20;
  config.kiosk_auto_logout_countdown = 20;
  config.login_error = "No photos for this account.  Please scan a band that was used at the photo station"
  config.select_all_enabled = '#EBA900';
  config.select_all_disabled = 'rgb(148 148 148)';
}
